<template>
  <v-app>
    <NavHeader />
    <router-view></router-view>
    <FooterComponent />
  </v-app>
</template>

<script>
import NavHeader from "./components/NavHeader.vue";
import FooterComponent from "./components/FooterComponent.vue";

export default {
  name: "HomeView",
  components: {
    NavHeader,
    FooterComponent,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
